/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { ObjectCategory } from "./models/object-category";

/*
 * Took out the following WOW Reports variables as this is now a setting
 * that is retrieved from the backend via a REST API so we don't have to 
 * have custom builds per customer. 
 * 
 * Keeping these here for reference, should be removed after a period of time.
 */
//URL for the WOW Reports Application
//export const Url_WowReports = "http://192.168.4.245:8080/wow76/run?id=1";     // Internal CYBRA Instance - Demo / Erin 
//export const Url_WowReports = "http://192.168.4.140:8480/wow76/run?id=1";     // Internal CYBRA Instance - NUC / Conference Room
//export const Url_WowReports = "http://192.168.4.4:8080/wow76/run?id=1"        // Internal CYBRA Instance - TJB Dev
//export const Url_WowReports = "http://192.168.4.110:8880/wow76/run?id=1"      // Internal CYBRA Instance - TJB OLD (Metal Rack)
//export const Url_WowReports = "http://10.11.20.10:8080/wow76/run?id=1";       // Thermofisher
//export const Url_WowReports = "http://3.129.56.12:8080/wow76/run?id=1";       // Living Room Pilot 2 (Static IP)
//export const Url_WowReports = "http://192.168.4.4:8080/wow76/run?id=1";       // TJB Dev Instance
//export const Url_WowReports = "http://10.137.227.25:8080/wow76/run?id=1";     // PVH 1 (Atlanta)
//export const Url_WowReports = "http://137.1.103.25:8080/wow76/run?id=1";      // PVH 2 (Jonesville)
//export const Url_WowReports = "http://10.20.30.68:8180/wow76/run?id=1";       // GrandView
//export const Url_WowReports = "http://10.5.1.37:8080/wow76/run?id=1"          // KISS

//Base URL for the relative path to the REST APIs
//Base URL path to use when running embedded in the backend application with the APIs
export const Url_Base = "/api";
//Base URL path to use when connecting to external APIs
//export const Url_Base = "http://localhost/api";
//export const Url_Base = "http://192.168.4.4/api";
//export const Url_Base = "http://192.168.4.110:8880/api" // Internal CYBRA Instance

//Image REST API Endpoints
export const Url_Images = `${Url_Base}/images/`;
export function Url_ImageById(id: number): string { 
  return `${Url_Images}${id}`;
}

//License REST API Endpoints
export const Url_LicenseBase = `${Url_Base}/license`;
export const Url_License_Compiled = `${Url_LicenseBase}/compiled-license`;
export const Url_License_Install = `${Url_LicenseBase}/install-license`;
export const Url_License_AvailableHardware = `${Url_LicenseBase}/available-hardware`;
export const Url_License_AllLicenses = `${Url_LicenseBase}/installed-licenses`;
export function Url_License_LicenseById(id: number): string {
  return `${Url_License_AllLicenses}/${id}`;
}

//Objects REST API Endpoints
export function Url_ObjectProperties_MainDisplayForCategory(category: ObjectCategory): string {
  return `${Url_Base}/objects/type/${category}/properties/main-display`;
}

//WS URL Builder
export function Url_WebSocket_BuildUrl(authToken: string, relativePath: string) {

  //Handle connecting to external APIs via HTTP
  if (Url_Base.startsWith("http://")) {
    return `ws://${Url_Base.substring(7)}/ws/${authToken}/${relativePath}`;
  } 
  
  //Handle connecting to external APIs via HTTPS
  else if (Url_Base.startsWith("https://")) {
    return `wss://${Url_Base.substring(8)}/ws/${authToken}/${relativePath}`;
  } 
  
  //Handle connecting to APIs using the relative path / request URL
  else {
    //Depending on the protocol being used (https / http), use the appropriate Web Socket Protocol (wss / ws)
    const wsProtocol = location.protocol == 'https:'? 'wss' : 'ws';
    return `${wsProtocol}://${location.host}/api/ws/${authToken}/${relativePath}`;
  }
}
